import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

export type PostoCombustivel = {
    estabelecimento: string;
    litrosMes: number;
    valorMes: number;
    totalAbast: number;
};

export const usePostosCombustivel = () => {
    const { userAgencyId } = useAuth();
    const [data, setData] = useState<PostoCombustivel[]>([]);
    const [loading, setLoading] = useState(false);

    const fetch = () => {
        if (!userAgencyId) return;
        setLoading(true);
        api.get(`/dashboard-postos/${userAgencyId}`)
            .then(res => { setData(res.data); setLoading(false); 
                console.log('PostosCombustivelController.fetch response:', res.data)
            })
            .catch(err => { console.error(err); setLoading(false); });
    };

    useEffect(() => { fetch(); }, [userAgencyId]);

    return { data, loading, refetch: fetch };
};
